export const IDLE = 'idle';
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const FAILED = 'failed';
export const ERROR = 'error';

export type LOADING_STATES =
  | typeof IDLE
  | typeof FAILED
  | typeof ERROR
  | typeof SUCCESS
  | typeof LOADING;

export const COLORS = [
  '#16a085',
  '#27ae60',
  '#2c3e50',
  '#f39c12',
  '#e74c3c',
  '#9b59b6',
  '#FB6964',
  '#342224',
  '#472E32',
  '#BDBB99',
  '#77B1A9',
  '#73A857',
];
